module.exports = __webpack_public_path__ + "img/logo-vn.bb77f4e3.png";